import phpTimeFormmatter from './phpTimeFormat';

/**
 * @function convertToLocalTime
 * @param  {HTMLTimeElement} element
 * @return {void}
 *
 * Converts a time element's dateTime attribute to a local time string using php format tokens.
 */
export default function convertToLocalTime(element) {
    const { dateTime } = element;
    const date = new Date(dateTime * 1000);

    if (dateTime !== undefined) {
        const { format, trim } = element.dataset;

        if (format) {
            element.textContent = phpTimeFormmatter.format(date, format);
        }

        if (trim == "1") {
            element.textContent = element.textContent.replace(':00', '');
        }
        
    } else {
        throw new Error('No dateTime attribute found on element.');
    }
}
